export function compose<A, B, C>(f: (a: A) => B, g: (b: B) => C): (a: A) => C
export function compose<A, B, C, D>(
  f: (a: A) => B,
  g: (b: B) => C,
  h: (c: C) => D
): (a: A) => D
export function compose<A, B, C, D, E>(
  f: (a: A) => B,
  g: (b: B) => C,
  h: (c: C) => D,
  i: (c: C) => E
): (a: A) => E
export function compose(..._: Function[]): Function {
  const fns = arguments
  return (x: any) => {
    for (let i = fns.length - 1; i >= 0; i--) {
      x = fns[i](x)
    }
    return x
  }
}
